import { Link } from "react-router-dom";
import LandingNav from "../landing/LandingNav";
import Footer from "../landing/Footer";
import { LEGAL_LAST_UPDATED } from "../../lib/legal";

export function LSection({ n, title, children }) {
  return (
    <section className="mt-10">
      <h2 className="font-heading text-xl font-bold tracking-tight text-zinc-950">
        {n}. {title}
      </h2>
      <div className="mt-3.5 space-y-3 text-[15px] leading-relaxed text-zinc-600">{children}</div>
    </section>
  );
}

export function LList({ items }) {
  return (
    <ul className="list-disc pl-5 space-y-1.5 marker:text-zinc-400">
      {items.map((item, i) => (
        <li key={i}>{item}</li>
      ))}
    </ul>
  );
}

export default function LegalPage({ title, subtitle, children, testid }) {
  return (
    <div className="min-h-screen bg-zinc-50" data-testid={testid}>
      <LandingNav />
      <main className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-14 sm:py-20">
        <div className="max-w-[800px] mx-auto">
          <p className="text-xs uppercase tracking-widest font-medium text-zinc-500 mb-4">Legal</p>
          <h1 className="font-heading text-3xl sm:text-4xl font-bold tracking-tight text-zinc-950 leading-[1.1]">
            {title}
          </h1>
          {subtitle && <p className="text-lg text-zinc-600 leading-relaxed mt-4">{subtitle}</p>}
          <p className="text-sm text-zinc-400 mt-5" data-testid="legal-last-updated">
            Última actualización: {LEGAL_LAST_UPDATED}
          </p>
          <div className="mt-10">{children}</div>
          <p className="text-sm text-zinc-400 mt-14 pt-8 border-t border-zinc-200/80">
            <Link to="/" className="underline underline-offset-2 hover:text-zinc-700 transition-colors">
              Volver a Asset Passport
            </Link>
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
